export default {
  items: null,
  loading: false,
  applicationSent: false,
  showForm: false,
}